module.exports = __webpack_public_path__ + "img/use_case.3eb581dc.png";